function parseStringArray(value) {
    if (Array.isArray(value)) {
        return value.map((v) => String(v).trim()).filter(Boolean);
    }
    if (typeof value === "string") {
        const trimmed = value.trim();
        if (!trimmed) return [];
        if (trimmed.startsWith("[")) {
            try {
                const parsed = JSON.parse(trimmed);
                return Array.isArray(parsed)
                    ? parsed.map((v) => String(v).trim()).filter(Boolean)
                    : [];
            } catch {
                return trimmed.split(/[,;\n]/).map((s) => s.trim()).filter(Boolean);
            }
        }
        return trimmed.split(/[,;\n]/).map((s) => s.trim()).filter(Boolean);
    }
    return [];
}

/**
 * Parse a JSON file of week blocks for scheme import.
 * Accepts a top-level array or { entries | weekBlocks | blocks }.
 */
export function parseSchemeImportRows(text) {
    const data = JSON.parse(text);
    const rows = Array.isArray(data)
        ? data
        : data.entries || data.weekBlocks || data.blocks || [];
    if (!Array.isArray(rows) || rows.length === 0) {
        throw new Error(
            'File must contain an array of week blocks, or an object with an "entries" array.'
        );
    }

    return rows
        .map((row, i) => {
            const weekFrom = Number(row.weekFrom) || i * 2 + 1;
            const weekTo = Number(row.weekTo) || weekFrom + 1;
            return {
                weekFrom,
                weekTo,
                dateFrom: row.dateFrom || undefined,
                dateTo: row.dateTo || undefined,
                coreElement: String(row.coreElement || "").trim(),
                topic: String(row.topic || "").trim(),
                successCriteria: String(row.successCriteria || "").trim(),
                plannedActivities: String(row.plannedActivities || "").trim(),
                teachingMethods: parseStringArray(row.teachingMethods),
                resources: parseStringArray(row.resources),
            };
        })
        .filter((row) => row.topic);
}
